import Atc from '~/Api/Analytics/Atc';

import mapVirtualPack, { RawVirtualPack } from './mapVirtualPack';
import RouteOfAdministration from './RouteOfAdministration';
import TherapeuticArea from './TherapeuticArea';
import VirtualBrand from './VirtualBrand';

export interface RawVirtualBrand {
	id: string;
	brandName: string;
	orphan: boolean;
	generic: boolean;
	biosimilar: boolean;
	originator: boolean;
	therapeuticAreas: { name: string }[];
	routesOfAdministration: { name: string }[];
	atcs: { code: string; activeSubstance: string }[];
	virtualPacks: RawVirtualPack[];
}

export default function mapVirtualBrand(virtualBrand: RawVirtualBrand): VirtualBrand {
	return new VirtualBrand(
		virtualBrand.id,
		virtualBrand.brandName,
		virtualBrand.orphan,
		virtualBrand.generic,
		virtualBrand.biosimilar,
		virtualBrand.originator,
		virtualBrand.therapeuticAreas.map(({ name }) => new TherapeuticArea(name)),
		virtualBrand.routesOfAdministration.map(({ name }) => new RouteOfAdministration(name)),
		virtualBrand.atcs.map((atc) => new Atc(atc.code, atc.activeSubstance)),
		virtualBrand.virtualPacks.map(mapVirtualPack)
	);
}
